// extracted by mini-css-extract-plugin
module.exports =  {"container":"_93444fe79c--container--rbkee","lock":"_93444fe79c--lock--_8T38","text":"_93444fe79c--text--o3IQv"};